import { render, staticRenderFns } from "./EmiratesPromoBanner.vue?vue&type=template&id=b1145550&scoped=true&"
import script from "./EmiratesPromoBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EmiratesPromoBanner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./EmiratesPromoBanner.vue?vue&type=style&index=0&id=b1145550&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1145550",
  null
  
)

export default component.exports